import {isNumeric, nonBlank} from "../../utils/epic.utils";

export class FormValueChangeItem {

  private readonly name: string;
  private readonly newValue: any;
  private readonly oldValue: any;
  private readonly initialValue: boolean;
  private readonly changeType: 'change' | 'patch' | undefined;

  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  constructor(name: string, newValue: any, oldValue?: any, initialValue?: boolean, changeType?: 'change' | 'patch') {
    this.name = name;
    this.newValue = newValue;
    this.oldValue = oldValue;
    this.initialValue = !!initialValue;
    this.changeType = changeType;
  }

  public getName(): string {
    return this.name;
  }

  public getValue(): any {
    return this.getNewValue();
  }

  public getOldValue(): any {
    return this.oldValue;
  }

  public getNewValue(): any {
    return this.newValue;
  }

  public isInitialValue(): boolean {
    return this.initialValue;
  }

  public notInitialValue(): boolean {
    return !this.isInitialValue();
  }

  public is(name: string): boolean {
    return name === this.getName();
  }

  public nonBlank(): boolean {
    return nonBlank(this.getNewValue());
  }

  public isNumeric(): boolean {
    return this.nonBlank() && isNumeric(this.getNewValue());
  }
}
